export const PASTE_ARM_CHAR_THRESHOLD = 2000;
export const MAX_FILE_BYTES = 15 * 1024 * 1024;

export type ComposerChip = {
    id: string;
    kind: "file";
    label: string;
    sizeHint: string;
    documentId: number;
    contentType: string;
    uploading?: boolean;
};

export function shouldArmPastedText(text: string): boolean {
    return text.length >= PASTE_ARM_CHAR_THRESHOLD;
}

export function labelFromPastedText(text: string, fallback: string): string {
    const line = text.split(/\r?\n/).map((l) => l.trim()).find(Boolean) || fallback;
    return line.replace(/["'${}`,]/g, "").slice(0, 48) || fallback;
}

export function displayNameFromFilename(filename: string, fallback = ""): string {
    const base = filename.replace(/\\/g, "/").split("/").pop() || filename;
    const stripped = base.replace(/\.(pdf|txt)$/i, "").trim();
    return stripped.replace(/["'${}`,]/g, "") || fallback || filename;
}

export function formatByteSize(n: number): string {
    if (n < 1024) return `${n} B`;
    if (n < 1024 * 1024) return `${Math.round(n / 1024)} KB`;
    return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

function fileMime(file: File): string {
    return (file.type || "").split(";")[0].trim().toLowerCase();
}

export function isPdfFile(file: File): boolean {
    if (fileMime(file) === "application/pdf") return true;
    return file.name.toLowerCase().endsWith(".pdf");
}

export function isPlainTextFile(file: File): boolean {
    if (fileMime(file) === "text/plain") return true;
    return file.name.toLowerCase().endsWith(".txt");
}

export function isAllowedDocumentFile(file: File): boolean {
    return isPdfFile(file) || isPlainTextFile(file);
}

export function documentContentType(file: File): string {
    if (isPdfFile(file)) return "application/pdf";
    return "text/plain";
}

let chipSeq = 0;
export function nextChipId(): string {
    chipSeq += 1;
    return `chip-${Date.now()}-${chipSeq}`;
}
